import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import CTASection from "@/components/CTASection";
import { FAQ } from "@/components/FAQ";
import { WhyUs } from "@/components/WhyUs";
import { Reviews } from "@/components/Reviews";
import { Integrations } from "@/components/Integrations";
import { Benefits } from "@/components/Benefits";
import { Comparison } from "@/components/Comparison";
import { Metrics } from "@/components/Metrics";
import { Pricing } from "@/components/Pricing";
import { Hero } from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import { Features } from "@/components/Features";
import { usePageMeta } from "@/hooks/usePageMeta";
import { HomepageStructuredData } from "@/components/HomepageStructuredData";
import { SkipToContent } from "@/components/SkipToContent";

const Index = () => {
  usePageMeta(
    "Shattara AI — The AI Tutor Built for Students",
    "Upload your materials. Get instant explanations, quizzes & flashcards personalized to your exact syllabus. Study smarter — not longer."
  );

  return (
    <div className="flex flex-col min-h-screen">
      <HomepageStructuredData />
      <SkipToContent />
      <Navigation />
      
      <main id="main-content">
        <Hero />
        
        <Metrics />
        <Features />
        <WhyUs />
        <HowItWorks />
        <Benefits />
        <Comparison />
        <Pricing />
        <Reviews />
        <Integrations />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
